import React from 'react'
import { VoxnelaMark } from '../ui/VoxnelaMark'

interface VoxnelaStudioHeroArtworkProps {
  compact?: boolean
  title?: string
  headingLevel?: 1 | 2
}

export const VoxnelaStudioHeroArtwork: React.FC<VoxnelaStudioHeroArtworkProps> = ({
  compact = false,
  title = 'Voxnela Studio',
  headingLevel = 2,
}) => {
  const Heading = headingLevel === 1 ? 'h1' : 'h2'

  return (
    <div
      className={`spone-pro-artwork voxnela-hero-artwork ${
        compact ? 'spone-pro-artwork--compact' : ''
      }${title ? ' spone-pro-artwork--with-title' : ''}`}
    >
      <div className="spone-pro-artwork__visual" aria-hidden="true">
        <div className="spone-pro-artwork__grid" />
        <div className="spone-pro-artwork__glow spone-pro-artwork__glow--one" />
        <div className="spone-pro-artwork__glow spone-pro-artwork__glow--two" />
        <div className="spone-pro-artwork__particle-field">
          <i className="spone-pro-artwork__particle spone-pro-artwork__particle--one" />
          <i className="spone-pro-artwork__particle spone-pro-artwork__particle--two" />
          <i className="spone-pro-artwork__particle spone-pro-artwork__particle--three" />
          <i className="spone-pro-artwork__particle spone-pro-artwork__particle--four" />
          <i className="spone-pro-artwork__particle spone-pro-artwork__particle--five" />
          <i className="spone-pro-artwork__particle spone-pro-artwork__particle--six" />
          <i className="spone-pro-artwork__particle spone-pro-artwork__particle--seven" />
          <i className="spone-pro-artwork__particle spone-pro-artwork__particle--eight" />
        </div>
        <div className="spone-pro-artwork__mark voxnela-hero-artwork__mark">
          <div className="voxnela-hero-mark-pill">
            <VoxnelaMark animated />
          </div>
        </div>
      </div>
      {title ? <Heading className="spone-pro-artwork__title">{title}</Heading> : null}
    </div>
  )
}
